var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8029 11.9875C31.5518 11.0385 30.7486 10.3891 29.7947 10.2393L21.7623 9.04054L18.1477 1.44848C17.746 0.549425 16.9428 0 16.0391 0C15.0853 0 14.1816 0.549425 13.78 1.44848L10.1654 9.04054L2.13291 10.3891C1.17906 10.539 0.375808 11.1883 0.124793 12.1373C-0.126222 13.0863 -0.0258161 13.9854 0.677025 14.7845L6.55077 20.7783L5.19529 29.1695C5.04468 30.1185 5.44631 31.1674 6.24955 31.7168C6.65118 31.8667 7.20341 31.9666 7.60503 31.9666C8.00666 31.9666 8.40828 31.8167 8.80991 31.7168L16.0391 27.8708L23.2684 31.7168C24.0716 32.1164 25.1259 32.1164 25.8287 31.567C26.632 31.0175 27.0336 30.1185 26.883 29.0196L25.5275 20.6284L31.4012 14.6347C31.9535 13.9854 32.2045 12.9365 31.8029 11.9875ZM23.2684 19.0301C22.8667 19.4297 22.7161 19.9791 22.7161 20.6284L24.172 29.1695L16.7922 25.1737C16.5412 25.0238 16.2399 24.9239 15.9889 24.9239C15.7379 24.9239 15.4367 25.0738 15.1857 25.1737L7.95646 29.1695L9.31194 20.6284C9.46255 20.079 9.16133 19.4297 8.7597 19.0301L2.73535 12.8865L11.0188 11.5379C11.5711 11.3881 12.0731 10.9885 12.3743 10.489L15.9889 2.89697L19.6035 10.489C19.8546 11.0385 20.4068 11.438 20.959 11.5379L29.2425 12.8865L23.2684 19.0301Z",
    fill: "#E8E9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.a7e2ac3c.svg";
export { ForwardRef as ReactComponent };